const ruRU= {
    login: {
      title: 'Войти',
      sign_in_btn: 'Войти'
    },
    bar: {
        logout: 'Выход',
        languages: 'Языки',
        settings: 'Открыть настройки'
    },
    language: {
      name: 'Русский (Россия)',
    },
    attributePage: {
        title: 'Изменения параметров',
        viewChanges: 'Посмотреть изменения',
        dateTime: 'Дата',
        notificationType: 'Тип уведомления',
        notificationValue: 'Значение уведомления',
        oldValue: 'Старое значение',
        newValue: 'Новое значение',
        accept: 'Принять',
        reject: 'Отклонить',
    },
    Home: 'Главная',
    load: 'Выполняется первоначальная загрузка...',
    Requested: "Запрошено",
    Viewed: "Просмотрено",
    Executing: "Выполнение",
    Completed: "Завершено",
    Expired: "Срок действия истек",
    Cancelled: "Отменено",
    Error: "Ошибка",
    Rejected: "Отклонено",
    error: 'Что-то пошло не так. Повторите попытку позже.',
    displayname: 'Отображаемое имя',
    givenname: 'Имя',
    surname: 'Фамилия',
    email: 'Адрес электронной почты',
    mail: 'Адрес электронной почты',
    name: 'Имя',
    firstname: 'Имя',
    lastname: 'Фамилия',
    footer_copyright: 'Все права защищены.'
  };
  
  export default ruRU;
  